(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  var toggle = event.target.closest('[data-ss-profile-toggle]');
  if (toggle) {
    var toggleCard = toggle.closest('.ss-catalog-card');
    if (!toggleCard) return;
    var open = !toggleCard.classList.contains('ss-profile-open');

    document.querySelectorAll('.ss-catalog-card.ss-profile-open').forEach(function(card) {
      if (card !== toggleCard) {
        card.classList.remove('ss-profile-open');
        var otherToggle = card.querySelector('[data-ss-profile-toggle]');
        if (otherToggle) {
          otherToggle.setAttribute('aria-expanded', 'false');
          var otherLabel = otherToggle.querySelector('[data-ss-profile-toggle-label]');
          if (otherLabel) otherLabel.textContent = otherToggle.dataset.showLabel;
        }
      }
    });

    toggleCard.classList.toggle('ss-profile-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    var label = toggle.querySelector('[data-ss-profile-toggle-label]');
    if (label) label.textContent = open ? toggle.dataset.hideLabel : toggle.dataset.showLabel;
    return;
  }

  var card = event.target.closest('.ss-catalog-card[data-ss-card-url]');
  if (!card) return;
  if (event.target.closest('a,button,input,select,textarea,label,form,summary,details')) return;
  window.location.href = card.dataset.ssCardUrl;
});
  } catch(e) { console.error(e); }
})();

})();
